import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';
import { Link } from 'react-router-dom';

import { media, rem, themed } from '@/shared/ui/core';

const modifiers = {
  selected: ({ theme }) => ({
    styles: `
      border-bottom-color: ${theme.primary.accent};

      a {
        span {
          color: ${theme.primary.accent};
        }
      }
    `,
  }),
};

export const TabNavStyled = styled.ul`
  width: 100%;
  max-width: 25rem;
  padding: 0;
  margin: 0 auto;
  list-style: none;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  @media ${media.mobileMin} {
    max-width: 25rem;
  }

  @media ${media.tabletMin} {
    max-width: 44.125rem;
  }

  @media ${media.desktopMin} {
    max-width: 57.5rem;
    padding-right: 1.25rem;
    margin: auto;

  }
`;

export const TabItem = styled.li`
  width: 100%;
  max-width: 11rem;
  border-bottom: solid ${themed('tabs.borderWidth', rem)} ${themed('primary.darkGray')};
  margin: 0 ${themed('tabs.spacing', rem)};
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  opacity: 1;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }

  @media ${media.mobileMin} {
    max-width: 25rem;
  }

  @media ${media.tabletMin} {
    max-width: 45.75rem;
  }

  @media ${media.desktopMin} {
    max-width: 100%;
  }

  ${applyStyleModifiers(modifiers)};
`;

export const TabLink = styled(Link)`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  text-decoration: none;

  span {
    font-size: ${themed('tabs.fontSize', rem)};
    font-weight: 600;
    color: ${themed('primary.darkGray')};
    display: block;
    margin-bottom: 0.5rem;
  }

  @media ${media.tabletMin} {
    span {
      font-size: 0.875rem;
    }
  }
`;

export const NavWrapper = styled.div.attrs({
  className: 'NavWrapper',
})`
  .Title {
    display: none;
  }

  @media ${media.desktopMin} {
    .Title {
      font-size: 1.875rem;
      color: ${themed('primary.text')};
      margin-bottom: 1.5rem;
      display: block;
    }
  }
`;
